import React, { useEffect, useState } from "react";
import { Button, Flex } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { copySite, getSiteList, insertSite } from "../apis/adminSiteApis";
import { useQuery } from "react-query";
import { PAGE_SIZE } from "CommonData";

function SiteDataTable() {
  const navigate = useNavigate();
  const [searchParams, setsearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getSiteList(PAGE_SIZE, page);
      setData(result);
    };
    fetchData();
  }, [page]);

  const setPage = (newpage) => {
    setsearchParams({page: String(newpage)});
  };

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => record?.rnum,
    },
    {
      accessor: "field_nm",
      title: "현장명",
      cellsStyle: {
        color: "blue",
  //      textDecoration: "underline",
      },
      onClick: function (e) {
        navigate(`/admin/site/${e.record.field_id}`, {state: {pg: page}});
      },
    },
    {
      accessor: "group_nm",
      title: "그룹명",
    },
    {
      accessor: "office_phone",
      title: "연락처",
    },
    {
      accessor: "reg_dt",
      title: "등록일",
    },
  ];

  const [selectedRecords, setSelectedRecords] = useState([]);

  const onSiteCopy = async (selectRecord) => {
    if (selectRecord.length !== 1) {
      alert("현장복사를 위해서는 현장 한 곳만 선택해주세요.");
    } else {
      try {
        await copySite(selectRecord[0].field_id, selectRecord[0].field_nm);
        alert("현장이 복사되었습니다.");
        const newList = await getSiteList(PAGE_SIZE, page);
        setData(newList);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const RegisterButton = () => {
    return (
      <Flex gap={10}>
        <Button variant="default" onClick={() => navigate("/admin/site/add", {state: {pg: page}})}>
          등록관리
        </Button>
        <Button variant="default" onClick={() => onSiteCopy(selectedRecords)}>
          현장복사
        </Button>
      </Flex>
    );
  };

  return (
    <SRD_DataTable
      data={data}
      columns={columns}
      registerButton={<RegisterButton />}
      idAccessor="field_id"
      selectedRecords={selectedRecords}
      setSelectedRecords={setSelectedRecords}
      page={page}
      setPage={setPage}
    />
  );
}

export default SiteDataTable;
